import { statusMeta } from "@/lib/bookings";

interface BookingStatusBadgeProps {
  status: string | null | undefined;
  className?: string;
}

export default function BookingStatusBadge({ status, className = "" }: BookingStatusBadgeProps) {
  const meta = statusMeta(status);
  return (
    <span
      className={`inline-flex items-center gap-1.5 whitespace-nowrap rounded-full px-2.5 py-1 text-xs font-medium ${meta.className} ${className}`}
    >
      <i className={meta.icon}></i>
      {meta.label}
    </span>
  );
}